import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { IIntegrationTriggerApi } from './base';
import { Result } from '../models/common/resultResponse';
import { KeyValue } from '../models/common';

const baseRoute: string = 'IntegrationTrigger';

export class IntegrationTriggerApi extends IIntegrationTriggerApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }
}